module.exports = __webpack_public_path__ + "static/media/Closed Captions Test-Navico Welcome Video_1639673400549.0a0e5c39.vtt";